module.exports = __webpack_public_path__ + "media/images/fit_3-3b56eb1e923365857a2e820abd9a48f6.png";